"use strict";

module.exports = require("../dnd/dnd");



//////////////////
// WEBPACK FOOTER
// ./~/fine-uploader/lib/dnd.js
// module id = 1404
// module chunks = 0